package ru.it_mozaika.sender.js.application.components.senders

import io.ktor.client.call.*
import io.ktor.http.*
import js.core.jso
import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import react.dom.onChange
import react.router.useNavigate
import ru.it_mozaika.sender.common.EMAIL_REGEX
import ru.it_mozaika.sender.common.models.Sender
import ru.it_mozaika.sender.common.models.SenderUpdateRequest
import ru.it_mozaika.sender.common.models.Store
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.context.StoreContext
import web.cssom.AlignItems
import web.cssom.px

external interface SenderDialogProps: Props {
    var isOpen: Boolean
    var onClose: () -> Unit
    var sender: Sender?
}

val senderDialog = FC<SenderDialogProps> { props ->
    val storeContext = useContext(StoreContext)
    val (name, setName) = useState<String>()
    val (store, setStore) = useState<Store>()
    val (email, setEmail) = useState<String>()
    val (reply, setReply) = useState<String>()
    val (disabledFields, setDisabledFields) = useState(true)
    val responseContext = useContext(RequestResultContext)
    val emailIsValid = email?.matches(EMAIL_REGEX)
    val replyIsValid = reply?.matches(EMAIL_REGEX)

    useEffect(props.sender) {
        if (props.sender == null) {
            setDisabledFields(false)
            setName(null)
            setStore(null)
            setEmail(null)
            setReply(null)
        } else {
            setDisabledFields(true)
            setName(props.sender!!.name)
            setStore(storeContext.storeList.find { it.id == props.sender!!.store })
            setEmail(props.sender!!.email)
            setReply(props.sender!!.reply)
        }
    }
    useEffect(props.sender, storeContext.currentStore) {
        if (props.sender != null) storeContext.setStore(props.sender!!.store)
        setStore(storeContext.currentStore)
    }
    Dialog {
        open = props.isOpen
        DialogTitle {
            +if (props.sender == null) {
                "Новый отправитель"
            } else {
                props.sender?.name
            }
        }
        DialogContent {
            Stack {
                direction = responsive(StackDirection.column)
                spacing = responsive(3)
                sx {
                    padding = 5.px
                }
                TextField {
                    this.value = name ?: ""
                    disabled = disabledFields
                    id = "sender-name-field"
                    label = ReactNode("Название:")
                    error = name.isNullOrBlank()
                    required = true
                    this.variant = FormControlVariant.outlined
                    this.onChange = { event ->
                        val value = event.target.asDynamic().value as String
                        setName(value)
                    }
                }
                StoresSelect {
                    disabled = disabledFields
                }
                FormControl {
                    error = email.isNullOrBlank() || emailIsValid == false
                    InputLabel {
                        htmlFor = "sender-email-input"
                        color = FormLabelColor.error
                        +"Email: "
                    }
                    OutlinedInput {
                        this.value = email ?: ""
                        disabled = disabledFields
                        id = "sender-email-field"
                        required = true
                        this.onChange = { event ->
                            val value = event.target.asDynamic().value as String
                            setEmail(value)
                        }
                        if (!email.isNullOrBlank() && !emailIsValid!!) {
                            endAdornment = InputAdornment.create {
                                this.position = InputAdornmentPosition.end
                                Tooltip {
                                    title = ReactNode("Некорректный формат email")
                                    mui.icons.material.WarningAmberSharp {
                                        color = SvgIconColor.warning
                                    }
                                }
                            }
                        }
                    }
                }
                FormControl {
                    error = reply.isNullOrBlank() || replyIsValid == false
                    InputLabel {
                        htmlFor = "sender-email-input"
                        color = FormLabelColor.error
                        +"Email для ответа: "
                    }
                    OutlinedInput {
                        disabled = disabledFields
                        this.value = reply ?: ""
                        id = "sender-response-email-filed"
                        label = ReactNode("Email для ответа: ")
                        required = true
                        this.onChange = { event ->
                            val value = event.target.asDynamic().value as String
                            setReply(value)
                        }
                        if (!reply.isNullOrBlank() && !replyIsValid!!) {
                            endAdornment = InputAdornment.create {
                                this.position = InputAdornmentPosition.end
                                Tooltip {
                                    title = ReactNode("Некорректный формат email для ответа")
                                    mui.icons.material.WarningAmberSharp {
                                        color = SvgIconColor.warning
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        DialogActions {
            DialogActions {
                sx {
                    alignItems = AlignItems.flexEnd
                }
                Stack {
                    direction = responsive(StackDirection.row)
                    spacing = responsive(2)
                    Button {
                        variant = ButtonVariant.outlined
                        this.color = ButtonColor.secondary
                        when {
                            props.sender == null -> {
                                disabled =
                                    name.isNullOrBlank() || store == null || emailIsValid == false || replyIsValid == false
                                +"Создать"
                            }

                            props.sender != null && disabledFields -> +"Редактировать"
                            props.sender != null && !disabledFields -> +"Сохранить изменения"
                        }
                        this.onClick = {
                            if (props.sender != null && disabledFields) {
                                setDisabledFields {
                                    !disabledFields
                                }
                            } else {
                                if (!name.isNullOrBlank() && store != null && !email.isNullOrBlank() && !reply.isNullOrBlank()) {
                                    Http.post(
                                        "/senders/${props.sender?.id}",
                                        SenderUpdateRequest(name, store.id, email, reply)
                                    ) { response ->
                                        setName(null)
                                        setEmail(null)
                                        setReply(null)
                                        responseContext.handleRequestRespond(response)
                                        props.onClose()
                                    }
                                }
                            }
                            if (props.sender == null) {
                                if (!name.isNullOrBlank() && store != null && !email.isNullOrBlank() && !reply.isNullOrBlank()) {
                                    Http.put(
                                        "/senders",
                                        SenderUpdateRequest(name, store.id, email, reply)
                                    ) { response ->
                                        setName(null)
                                        setEmail(null)
                                        setReply(null)
                                        responseContext.handleRequestRespond(response)
                                        props.onClose()
                                    }
                                }
                            }
                        }
                    }
                    Button {
                        +"Отмена"
                        color = ButtonColor.error
                        variant = ButtonVariant.outlined
                        onClick = {
                            props.onClose()
                        }
                    }
                }
            }
        }
    }
}